var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticStyle:{"width":"100vw","height":"auto"},attrs:{"src":require("../../assets/jft.png"),"alt":""}})])
}]

export { render, staticRenderFns }